module.exports = __webpack_public_path__ + "img/20220411_130412.da3a5119.jpg";